import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-details-item-overflow',
    templateUrl: './details-item-overflow.component.html',
    styleUrls: [
        './details-item-overflow.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DetailsItemOverflowComponent
{
    @Input() icon: string = 'fa';
    @Input() value: string;
    @Input() keyTrad: string;
}
